import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    fallback: String,
    removeOnError: { type: Boolean, default: false }
  }

  connect () {
    this.element.addEventListener('error', this.handleError.bind(this))
  }

  handleError (event) {
    if (this.removeOnErrorValue) {
      const container = this.element.closest('[data-image-container]')
      if (container) {
        container.remove()
      } else {
        this.element.remove()
      }
    }

    if (!this.element.dataset.loaded) {
      this.element.src = this.fallbackValue
      this.element.dataset.loaded = 'true'
    }
  }
}
